import React from "react"
import { Card, Col, Row } from "reactstrap"
import styles from "./InfoCard.module.scss"

const InfoCard = ({ title, headerColor, data, children }) => {
  return (
    <>
      <Card className={styles.infoCard}>
        <div style={{ backgroundColor: headerColor }} className={styles.cardHeader}>
          {title}
        </div>
        <div className={styles.cardBody}>
          {data.map((item, index) => (
            <Row key={index} className={styles.infoList}>
              <Col className={styles.infoLabel}>{item.label}:</Col>
              <Col>{item.value}</Col>
            </Row>
          ))}
        </div>
        {children && <div className={styles.cardFooter}>{children}</div>}
      </Card>
    </>
  )
}

export default InfoCard
